import './polyfill/nodelist-foreach.js'

// import external dependencies
import 'jquery'

import AOS from 'aos'

// Import everything from autoload


// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import singleTalent from './routes/single-talent'
import singleWork from './routes/single-work'
import single from './routes/single'

import Cursor from './components/cursor'
import './blocks/Blog.js'; import './blocks/Carousel.js'; import './blocks/Content.js'; import './blocks/Counter.js'; import './blocks/Map.js'; import './blocks/Talent.js'; import './blocks/Work.js'


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  singleTalent,
  singleWork,
  single,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

AOS.init({
  once: true,
});

 

window.addEventListener('DOMContentLoaded', () => {
  Cursor.init();
});


// WEBPACK FOOTER //
// ./scripts/main.js